import despesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'gerentes',
    name: 'DespesasGerais_Gerentes',
    component: {
        render(c) {
            return c('router-view')
        }
    }, 
    children: [despesasRotas, PagamentosRotas]
}